export default __webpack_public_path__ + "static/media/img-waiting.152b8d9b.svg";